<template>
  <div class="row f-row h-100">
    <div class="col col-12 text-center results-divider">
      <!-- Chart -->
      <div class="d-flex flex-column" style="height: calc(100% - 190px)">
        <!-- Row: title and resize button -->
        <div class="row f-row">
          <div class="markets-chart-title text-left d-flex">
            <span class="mr-auto">
              FEP VS CIF ROTTERDAM HISTORICAL AND SWAPS
            </span>
          </div>
        </div>
        <!-- Row: Historical time selector -->
        <div class="row f-row spot-row mt-1">
          <div class="col col-auto txt-label-primary-2 text-left">
            <i class="fa fa-minus ml-1 mr-1" style="color:var(--expo)"></i>
            FEP
            <i class="fa fa-minus ml-1" style="color:var(--hedge)"></i>
            <span class="inline-ul ml-1">CIF ROTTERDAM</span>
          </div>
          <div class="col col-3" style="height:90%; width:100%;">
            <HistoricalInterval
              :showTitle="false"
              :initPickedDateInterval="pickedIntervalHistory"
              @eventOnChangeInterval="onHistoricalIntervalChange"
            />
          </div>
          <div class="col col-cx mr-2 ml-2" style="height:90%; width:100%;">
            <RangeSlider
              :labelTxt="'ZOOM:'"
              :dates="xRange.length > 1 ? xRange.slice(0, -1) : xRange"
              :minIdx="zoomInitial"
              :maxIdx="zoomFinal"
              @eventOnMinRange="eventMinRange"
              @eventOnMaxRange="eventMaxRange"
            />
          </div>
        </div>
        <!-- Row: Chart -->
        <CPOComparisonChart
          :allData="allData.slice(0, -1)"
          :allData2="allDataRott.slice(1)"
          :colorTheme="colorTheme"
          :comp="comp"
          :compRott="compRott"
          :div1Name="'fep_hist-div'"
          :div2Name="'fep_fwd-div'"
          :fwdData="allData.slice(0, -1)"
          :fwdData2="allDataRott.slice(1)"
          :histData="histFEP"
          :histData2="histRott"
          :histData2Monthly="histRottMonthly"
          :interval="interval"
          :monthData="monthFEP"
          :monthData2="monthRott"
          :processData="processData"
          :progressPosition="37"
          :renderChartsSignal="renderFEPSignal"
          :showLoading="showLoadingAllCalcs"
          :svg1Name="'svg1-fep_hist'"
          :svg2Name="'svg2-fep_fwd'"
        />
      </div>

      <!-- Table -->
      <div class="d-flex flex-column bdr-t" style="width: 100%; height: 190px">
        <CPOTableComparison
          :freight="freight"
          :tariff="tariff"
          :aveDataFEP="aveDataFEP"
          :comp="comp"
          :freightRott="freightRott"
          :tariffRott="tariffRott"
          :aveDataRott="aveDataRott"
          :compRott="compRott"
          :inDate="xRange[zoomInitial === 0 ? 1 : zoomInitial]"
          :endDate="xRange[zoomFinal]"
          @eventOnUserFreightChange="onUserFreightChange"
          @eventOnUserTariffChange="onUserTariffChange"
          @eventOnUserFreightChangeRott="onUserFreightChangeRott"
          @eventOnUserTariffChangeRott="onUserTariffChangeRott"
          @eventOnUserCompChange="onUserCompChange"
          @eventOnUserCompChangeRott="onUserCompChangeRott"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CPOComparisonChart from "@/components/markets/CPOComparisonChart";
import CPOTableComparison from "@/components/markets/CPOTableComparison";
import HistoricalInterval from "@/components/intervals/AnalyticsHistoricalInterval";
import RangeSlider from "@/components/analytics/RangeSlider";

export default {
  name: "CPOColComparison",
  components: {
    CPOComparisonChart,
    CPOTableComparison,
    HistoricalInterval,
    RangeSlider
  },
  props: {
    allData: { required: true, default: () => [] },
    allDataRott: { required: true, default: () => [] },
    aveDataFEP: { required: true, default: () => [] },
    aveDataRott: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    comp: { required: true },
    compRott: { required: true },
    freight: { required: true },
    freightRott: { required: true },
    histFEP: { required: true, default: () => [] },
    histRott: { required: true, default: () => [] },
    histRottMonthly: { required: true, default: () => [] },
    interval: { required: true },
    monthFEP: { required: true, default: () => [] },
    monthRott: { required: true, default: () => [] },
    pickedIntervalHistory: { required: true },
    renderFEPSignal: { required: true, default: 0 },
    showLoadingAllCalcs: { required: true, type: Boolean, default: false },
    tariff: { required: true },
    tariffRott: { required: true },
    xRange: { required: true },
    zoomFinal: { required: true },
    zoomInitial: { required: true },
    // ============ Data Classes ===============
    processData: { required: true }
  },
  data() {
    return {
      pickedIntervalHistoryAux: "",
      expandAnimation: false
    };
  },
  methods: {
    // === user interactions ===
    onHistoricalIntervalChange(val) {
      this.$emit("eventOnChangeInterval", val);
    },
    eventMinRange(val) {
      this.$emit("eventOnMinRange", val);
    },
    eventMaxRange(val) {
      this.$emit("eventOnMaxRange", val);
    },
    onUserFreightChange(val) {
      this.$emit("eventOnUserFreightChange", val);
    },
    onUserTariffChange(val) {
      this.$emit("eventOnUserTariffChange", val);
    },
    onUserFreightChangeRott(val) {
      this.$emit("eventOnUserFreightChangeRott", val);
    },
    onUserTariffChangeRott(val) {
      this.$emit("eventOnUserTariffChangeRott", val);
    },
    onUserCompChange(val) {
      this.$emit("eventOnUserCompChange", val);
    },
    onUserCompChangeRott(val) {
      this.$emit("eventOnUserCompChangeRott", val);
    }
  }
};
</script>

<style scoped></style>
